import {Pipe, PipeTransform} from '@angular/core';
import {DateUtils} from '../utils/date.utils';

@Pipe({name: 'timeFromNow'})
export class TimeFromNowPipe implements PipeTransform {

	transform(date: Date): string {
		return DateUtils.timeFromNow(date);
	}
}